import { Input, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IOrderVoucherCodeProps } from "../../models/interface/IOrderVoucherCodeProps";
import { selectCart } from "../../redux/reducers/slice/cart";

const OrderVoucherCode = (props: IOrderVoucherCodeProps) => {
  const { t } = props;
  const [code, setCode] = useState<string>();
  const refInputCode = useRef<Input>(null);

  const carts = useSelector(selectCart);

  useEffect(() => {
    setCode(carts?.order_voucher?.code);
    if (refInputCode?.current && carts?.order_voucher?.code) {
      refInputCode?.current?.setValue(carts.order_voucher.code);
    }
  }, [carts?.order_voucher?.code]);

  return code ? (
    <div className="shopping-cart-voucher-code-wrapper">
      <label className="voucher-code-label">
        {t("shopping_cart_voucher_code_label")}
      </label>
      <div className="voucher-code-ctrl">
        <Typography.Text className="voucher-code-name" type="success">
          {carts?.order_voucher?.name}
        </Typography.Text>
      </div>
    </div>
  ) : null;
};
export default withTranslation()(OrderVoucherCode);
